module.exports = __webpack_public_path__ + "img/backhoe-loader.b78399c.png";